// src/App.tsx
// Auto-generated by corebuilder. Edit freely.

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppShell } from './layouts/AppShell';

import { LoginPage } from './pages/auth/LoginPage';
import { RegisterPage } from './pages/auth/RegisterPage';
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/auth/ResetPasswordPage';
import { VerifyEmailPage } from './pages/auth/VerifyEmailPage';
import { TwoFactorChallengePage } from './pages/auth/TwoFactorChallengePage';
import { OAuthConsentPage } from './pages/auth/OAuthConsentPage';
import { OAuthCallbackPage } from './pages/auth/OAuthCallbackPage';
import { DeviceAuthPage } from './pages/auth/DeviceAuthPage';

import { PublicLandingPage } from './pages/landing/PublicLandingPage';

import { PublicBookingPage } from './pages/calendar/PublicBookingPage';

import { PublicFormFillPage } from './pages/form/PublicFormFillPage';

import { ProtectedRoute } from './components/ProtectedRoute';
import { ThemeFavicon } from './components/ThemeFavicon';

/**
 * Main App component with routing.
 */
function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ThemeFavicon />
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/2fa-challenge" element={<TwoFactorChallengePage />} />
        <Route path="/oauth/consent" element={<OAuthConsentPage />} />
        <Route path="/oauth/callback" element={<OAuthCallbackPage />} />
        <Route path="/device-auth" element={<DeviceAuthPage />} />
        {/* Public booking page — unauthenticated visitors book a slot */}
        <Route path="/book/:slug" element={<PublicBookingPage />} />
        {/* Public form-fill page — unauthenticated respondents, mirrors /book/:slug */}
        <Route path="/f/:formId" element={<PublicFormFillPage />} />
        {/* Public landing page render — unauthenticated visitors, mirrors /book/:slug */}
        <Route path="/l/:slug" element={<PublicLandingPage />} />

        {/* Protected area. One route now, because the page is chosen inside the
            workspace: every tab runs its own router, so the browser URL only
            says where the focused tab is. AppRoutes holds the page tree. */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        />

        {/* Catch all - redirect to inbox */}
        <Route path="*" element={<Navigate to="/inbox" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
